import { ITreeNodeModel, ISubGroupModel } from "./Interfaces/ITreeNodeModel";
import { CheckedState } from "./enums/CheckedState";
import { app } from "../../../Frame/App";

export class TreeNodeModel implements ITreeNodeModel {
    displayProperty: string;
    colorProperty?: string;
    businessModel: any;
    children: TreeNodeModel[];
    parent: TreeNodeModel;
    selected: CheckedState = CheckedState.Unchecked;
    level: number;

    /**
     * This property determines if the node will be visible in the tree. It is used in the filtering process.
     * Nodes that aren't visible didn't meet the filter criteria. Beware: this is semantically different from
     * the visible property on the business model.
     */
    visible: boolean = true;

    availableSubGroups: SubGroupModel[] = [];
    parentSubGroup: SubGroupModel;

    getGroupedChildren = () => {
        let groupedArray = this.children.reduce((acc, item) => {
            acc[item.parentSubGroup.id] = acc[item.parentSubGroup.id] || [];
            acc[item.parentSubGroup.id].push(item);
            return acc;
        }, {});

        return groupedArray;
    }

    getDisplayName = () => {
        if (this.businessModel[this.displayProperty]
            && (this.businessModel[this.displayProperty]["valueCs"]
                || this.businessModel[this.displayProperty]["valueDe"]
                || this.businessModel[this.displayProperty]["valueEn"]
                || this.businessModel[this.displayProperty]["valueFr"]
                || this.businessModel[this.displayProperty]["valueKo"]
                || this.businessModel[this.displayProperty]["valueNl"]
                || this.businessModel[this.displayProperty]["valueRu"]
                || this.businessModel[this.displayProperty]["valueSv"])
        ) {
            return app.getNameInLanguage(this.businessModel[this.displayProperty]);
        } else {
            return this.businessModel[this.displayProperty];
        }
    }
}

export class SubGroupModel implements ISubGroupModel {
    businessModel: any;

    id: string;
    name: string;
}